import MainLayout from '../../layouts/MainLayout'

export default function DesignDockError(): JSX.Element {
  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">

          <div className="flex flex-col items-center w-full bg-white rounded-xl p-4 lg:p-5">
            <div className="flex w-full mb-4">
              <header className="mb-4">
                <h1 className="sm:text-2xl text-xl font-bold">Design Dock - Error</h1>
              </header>
            </div>

            <div className="flex flex-col w-full">
              <div className="bg-yellow-primary rounded-lg">
                Unable to login
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}
